<div class="padding flex column">
	<h4 class="bold margin-bottom-small">{{ data.title }}</h4>

	{{ data.message }}

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="onClose(false)" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>
			<button (click)="onClose(true)">
				<i class="fa-solid fa-check"></i>
				Confirm
			</button>
		</div>
	</div>
</div>
